export default __webpack_public_path__ + "static/media/algo.19638390.png";